import React, {useEffect, useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';

const GoodIcon = ({ isGood, chatHistoryId, onClick }) => {
    const [good, setGood] = useState(isGood);
    
    useEffect(() => {
        setGood(isGood);
    }, [isGood])
    
    const handleClick = () => {
      onClick(chatHistoryId, !good); // Goodを選択
      setGood(!good)
    };
    
    return (
      <div className="div-icon-underbar" onClick={handleClick} >
        <FontAwesomeIcon icon={faThumbsUp} className={`icon-underbar ${good ? 'icon-bold' : 'icon-normal'}`} />
      </div>
    )
}

export default GoodIcon